// extracted by mini-css-extract-plugin
export default {"-large":"UKwkq0Gg_dBquR6yLHLS","chatPromptAttachment":"UMnZfyMF0skyaQPxZ8ad","userMessage":"RhjSXyFA7vbqzy9TZikL","userText":"WfRi28JK4HL7wg1PItZG"};